import { render, staticRenderFns } from "./Proxy.vue?vue&type=template&id=749f87d6&scoped=true"
import script from "./Proxy.vue?vue&type=script&lang=js"
export * from "./Proxy.vue?vue&type=script&lang=js"
import style0 from "./Proxy.vue?vue&type=style&index=0&id=749f87d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749f87d6",
  null
  
)

export default component.exports